module.exports = __webpack_public_path__ + "img/Awards.18475dda.svg";